import { Box, styled, Typography } from '@mui/material';
import { VIEW_PLAN_LINK_COLOR } from '../../constants/reentry-planning.constants';

export const ViewPlanLink = styled(Typography)(() => ({
  color: VIEW_PLAN_LINK_COLOR,
  cursor: 'pointer',
  fontWeight: 700,
  whiteSpace: 'nowrap',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const PreviewEmptyStateWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '40px 24px',
  boxSizing: 'border-box',
  width: '100%',
}));

export const PreviewEmptyStateContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
  maxWidth: '500px',
}));

export const DataGridWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
  '& div': {
    boxSizing: 'border-box',
  },
  '& svg.sort-icon.active': {
    left: '-3px !important',
  },
  '& > div:nth-child(2)': {
    padding: '0 25px',
  },
}));
